import { contactInfo } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            {contactInfo.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">{contactInfo.subtitle}</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="w-full lg:w-2/5 flex flex-col gap-5">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {contactInfo.intro}
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">电子邮箱</p>
                  <p className="text-sm text-foreground-800">{contactInfo.email}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">响应时间</p>
                  <p className="text-sm text-foreground-800">工作时间 2 小时内回复</p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <form
              data-readdy-form
              id="contact-form"
              className="flex flex-col gap-4 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60"
              action={contactInfo.submitAddr}
              method="POST"
              encType="application/x-www-form-urlencoded"
              onSubmit={function (e: React.FormEvent<HTMLFormElement>) {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                if (honeypot) {
                  const success = form.querySelector('.form-success') as HTMLElement;
                  if (success) success.style.display = 'block';
                  return;
                }
                const formData = new FormData(form);
                const url = form.getAttribute('action') || '';
                const body = new URLSearchParams();
                formData.forEach((value, key) => {
                  if (key !== 'phone_alt') {
                    body.append(key, value as string);
                  }
                });
                fetch(url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: body.toString(),
                })
                  .then(async (res) => {
                    const text = await res.text();
                    let parsed: Record<string, unknown> = {};
                    try { parsed = JSON.parse(text); } catch { /* ignore */ }
                    if (res.ok && (parsed as { code?: string })?.code === 'OK') {
                      const successEl = form.querySelector('.form-success') as HTMLElement;
                      const errorEl = form.querySelector('.form-error') as HTMLElement;
                      if (successEl) successEl.style.display = 'block';
                      if (errorEl) errorEl.style.display = 'none';
                      form.reset();
                    } else {
                      const errorEl = form.querySelector('.form-error') as HTMLElement;
                      if (errorEl) {
                        errorEl.style.display = 'block';
                        const msg = (parsed as { meta?: { message?: string } })?.meta?.message
                          || (parsed as { message?: string })?.message
                          || (parsed as { meta?: { detail?: string } })?.meta?.detail
                          || text;
                        errorEl.textContent = msg || '提交失败，请稍后重试';
                      }
                    }
                  })
                  .catch(() => {
                    const errorEl = form.querySelector('.form-error') as HTMLElement;
                    if (errorEl) {
                      errorEl.style.display = 'block';
                      errorEl.textContent = '网络错误，请稍后重试';
                    }
                  });
              }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="contact-name" className="text-xs font-medium text-foreground-700">
                    你的名字
                  </label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    required
                    placeholder="请输入你的名字"
                    className="px-4 py-2.5 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="contact-email" className="text-xs font-medium text-foreground-700">
                    电子邮箱
                  </label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    required
                    placeholder="请输入你的邮箱"
                    className="px-4 py-2.5 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <label htmlFor="contact-subject" className="text-xs font-medium text-foreground-700">
                  主题
                </label>
                <select
                  id="contact-subject"
                  name="subject"
                  required
                  className="px-4 py-2.5 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors cursor-pointer"
                >
                  <option value="">请选择主题</option>
                  <option value="作品推荐">作品推荐</option>
                  <option value="问题反馈">问题反馈</option>
                  <option value="内容合作">内容合作</option>
                  <option value="商务洽谈">商务洽谈</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div className="flex flex-col gap-1.5">
                <label htmlFor="contact-message" className="text-xs font-medium text-foreground-700">
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="请输入你想说的话，限500字"
                  className="px-4 py-2.5 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                ></textarea>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />

              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                发送留言
              </button>

              <div className="form-success hidden text-sm text-secondary-600 bg-secondary-50 border border-secondary-200/60 rounded-xl p-3 text-center">
                留言发送成功！我们会尽快与你联系。
              </div>
              <div className="form-error hidden text-sm text-primary-600 bg-primary-50 border border-primary-200/60 rounded-xl p-3 text-center"></div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}